var map = {
	"./arrow-bottom-2.svg": 3295,
	"./arrow-bottom.svg": 4294,
	"./arrow-left.svg": 464,
	"./arrow-right-2.svg": 714,
	"./arrow-right.svg": 415,
	"./buy.svg": 9525,
	"./call.svg": 8975,
	"./documents.svg": 459,
	"./leads.svg": 2560,
	"./lk.svg": 4004,
	"./logo.svg": 1426,
	"./message.svg": 904,
	"./passport.svg": 7357,
	"./pencil.svg": 3336,
	"./plus.svg": 7099,
	"./reply_transfer.svg": 8877,
	"./settings.svg": 6492,
	"./star.svg": 447,
	"./star_active.svg": 6312,
	"./tg.svg": 5608,
	"./timetable.svg": 8956,
	"./vk.svg": 4678,
	"./x.svg": 969
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8131;